export default __webpack_public_path__ + "static/Ben-822a3aa4788fdca734ca98eee1fff55b.png";